import { configure } from '@37signals/lexxy'
import { CommandsExtension } from './commands'
import { VariableExtension } from './variables'

configure({
  global: { extensions: [CommandsExtension, VariableExtension] },
  default: { variables: [] }
})
